import React, { useState } from "react";
import UserLayout from "../../../../components/user-layout/UserLayout";

import styles from "./userMgmt.module.scss";
import authService from "../../../../utils/services/authService";
import { useEffect } from "react";
import { NavLink } from "react-router-dom";

const UserMgmt = () => {
  const [developers, setDevelopers] = useState();
  const [companies, setCompanies] = useState();
  const [selected, setSelected] = useState("developer");

  const userData = authService.getUserData();

  useEffect(() => {
    authService.getAllDevelopers(userData).then((res) => {
      if (res.data.success) {
        setDevelopers(res?.data.data);
      }
    });

    authService.getAllCompanies(userData).then((res) => {
      if (res.data.success) {
        setCompanies(res?.data.data);
      }
    });
  }, []);

  const deleteClickHandle = async (e, role, id) => {
    e.preventDefault();

    const result = await authService.deleteUser(id, role, userData);
    console.log(result.data);
    if (result.data.success) {
      const array = [...developers];
      const updatedArray = array.filter((dev) => dev._id !== id);
      setDevelopers(updatedArray);
    }
  };

  const selectRoleHandle = (e) => {
    e.preventDefault();
    setSelected(e.target.value);
  };

  return (
    <UserLayout>
      <section className={styles.userMgmtWrapper}>
        <h1 className={styles.userMgmtWrapper_heading}>User management</h1>

        <section className={styles.userSelection}>
          <button
            className={`${styles.userSelection_btn} ${
              selected === "developer" ? styles.active : ""
            }`}
            value="developer"
            onClick={(e) => {
              selectRoleHandle(e);
            }}
          >
            Developers
          </button>
          <button
            className={`${styles.userSelection_btn} ${
              selected === "company" ? styles.active : ""
            }`}
            value="company"
            onClick={(e) => {
              selectRoleHandle(e);
            }}
          >
            Companies
          </button>
        </section>

        <section className={styles.resultWrapper}>
          {selected === "company"
            ? companies?.map((company, index) => (
                <>
                  <div className={styles.userCard} key={index}>
                    <p className={styles.userCard_name}>
                      {company.companyName}
                    </p>
                    <p className={styles.userCard_email}>{company.email}</p>
                    <div className={styles.buttonWrapper}>
                      <NavLink
                        className={styles.buttonWrapper_edit}
                        to={`${company.role}/${company._id}`}
                      >
                        Edit
                      </NavLink>
                      <button
                        className={styles.buttonWrapper_delete}
                        onClick={(e) => {
                          // deleteClickHandle(e, company.role, company._id);
                          alert("This feature is coming soon");
                        }}
                      >
                        Delete
                      </button>
                    </div>
                  </div>
                </>
              ))
            : developers?.map((developer, index) => (
                <div className={styles.userCard}>
                  <p className={styles.userCard_name}>{developer.name}</p>
                  <p className={styles.userCard_email}>{developer.email}</p>
                  <div className={styles.buttonWrapper}>
                    <NavLink
                      className={styles.buttonWrapper_edit}
                      to={`${developer.role}/${developer._id}`}
                    >
                      Edit
                    </NavLink>
                    <button
                      className={styles.buttonWrapper_delete}
                      onClick={(e) => {
                        deleteClickHandle(e, developer.role, developer._id);
                      }}
                    >
                      Delete
                    </button>
                  </div>
                </div>
              ))}
        </section>
      </section>
    </UserLayout>
  );
};

export default UserMgmt;
